module.exports = __webpack_public_path__ + "static/img/dress_yinzhang_default.9cdc31bc.png";